module.exports = __webpack_public_path__ + "img/arrow-next.5da6dde1.svg";